<template>
    <b-container>
        <b-row>
            <b-col cols="6" lg="3">
                <DateInput v-model="fromDate"></DateInput>
            </b-col>
            <b-col cols="6" lg="3">
                <DateInput v-model="toDate"></DateInput>
            </b-col>
            <b-col cols="6" lg="3">
                <b-form-select v-model="interval" :options="intervalOptions"></b-form-select>
            </b-col>
            <b-col cols="6" lg="3">
                <b-button-group block class="w-100">
                    <b-button @click="getData">{{$t('admin_report.show_report')}}</b-button>
                    <b-button variant="light" @click="exportData"><font-awesome-icon icon="file-export"></font-awesome-icon></b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <BarChart :chart-data="chartData" height="200px"></BarChart>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {DateTime} from 'luxon'
    import BarChart from "./BarChart";
    import DateInput from "../DateInput";
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faFileExport} from '@fortawesome/free-solid-svg-icons'

    library.add(faFileExport);

    export default {
        name: 'SpecialOfferCountReport',
        components: {DateInput, BarChart},
        data() {
            return {
                fromDate: DateTime.local().startOf('year').toISO(),
                toDate: DateTime.local().endOf('year').toISO(),
                interval: 1,
                intervalOptions: [
                    {value: 1, text: this.$t('admin_report.interval_month')},
                    {value: 12, text: this.$t('admin_report.interval_year')},
                ],

                rawData: [],
            }
        },
        computed: {
            chartData() {
                let labels = this.rawData.map(function (d) {
                    return d.label;
                });

                let data = this.rawData.map(function (d) {
                    return d.value;
                });

                return {
                    labels: labels,
                    datasets: [{
                        label: this.$t('admin_report.special_offer_count'),
                        data: data,
                    }],
                }
            },
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                this.$callAPI('hkiarace/admin/report/', {
                    report_type: 'SPECIAL_OFFER_COUNT',
                    params: {
                        from: DateTime.fromISO(this.fromDate).toSeconds(),
                        to: DateTime.fromISO(this.toDate).toSeconds(),
                        interval: this.interval,
                    },
                }, function (response) {
                    this.rawData = response.body.datasets;
                })
            },
            exportData() {
                this.$downloadFile('hkiarace/admin/report/export/', {
                        report_type: 'SPECIAL_OFFER_COUNT',
                        params: {
                            from: DateTime.fromISO(this.fromDate).toSeconds(),
                            to: DateTime.fromISO(this.toDate).toSeconds(),
                            interval: this.interval,
                        },
                    }, 'export.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            },
        },
    }
</script>

<style>

</style>
